import { render, staticRenderFns } from "./quanLySinhVien.vue?vue&type=template&id=79645188&"
import script from "./quanLySinhVien.vue?vue&type=script&lang=js&"
export * from "./quanLySinhVien.vue?vue&type=script&lang=js&"
import style0 from "./quanLySinhVien.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports